import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { getFlowKey } from '../routing/getFlowKey';
export const getFlowSpecificErrorMessage = (dataKey, error) => {
  const flowKey = getFlowKey();
  const defaultMessage = `data.${dataKey}.default.error.${error}`;
  const flowSpecificMessage = `data.${dataKey}.${flowKey}.error.${error}`;
  const errorKey = isValidI18nKey(flowSpecificMessage) ? flowSpecificMessage : defaultMessage;
  return errorKey;
};